var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyPlaneDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.683,
    height: 24.514,
    viewBox: "0 0 23.683 24.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Page_1_Copy_2",
    "data-name": "Page 1 Copy 2",
    d: "M.275,6.5l1.549.722a.476.476,0,0,0,.45-.026l3.04-1.868A.476.476,0,0,1,5.776,5.3l9.412,4.774.033.019a9.722,9.722,0,0,0,5.453,1.334s2.218.236,1.98-1.348c-.23-1.523-5.148-3.629-6.652-4.07a.463.463,0,0,1-.262-.2L12.669.953a.474.474,0,0,0-.228-.189L10.58.033a.475.475,0,0,0-.648.414L9.776,3.021a.475.475,0,0,1-.645.415A24.816,24.816,0,0,0,1.259,1.7c-.341,0,.382.859.815,1.342a.474.474,0,0,1-.009.643L.13,5.739A.475.475,0,0,0,.275,6.5Z",
    transform: "translate(23.683 7.665) rotate(132)",
    fill: "#bfc7d2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyPlaneDown);
export default __webpack_public_path__ + "static/media/grey-plane-down.6e9f8b55218d019adc1c4c6869ec7633.svg";
export { ForwardRef as ReactComponent };